<template>
  <div class="showResultBox" id="mainBox">
    <div class="emptyBox y-f y-f-a y-f-js" v-if="!tableData.length&&!historyList.length">
      <img class="robotImg y-f-shrink" src="@/assets/images/gpt/3@2x.png">
      <div class="emptyRight">
        <div class="emptyTitle">
          <img src="@/assets/images/gpt/icon_sel_reputation@2x.png">
          <span>{{emptyTip.title}}</span>
        </div>
        <div class="emptyDesp">{{emptyTip.desp}}</div>
      </div>
    </div>
    <div v-else>
      <div class="resultParentBox" v-if="tableData.length">
        <div class="tit-desp">生成结果</div>
        <div class="resultMainBox">
          <div class="y-f y-f-a y-f-jb">
            <div class="y-f y-f-a y-f-js">
              <el-image
                lazy
                v-if="tableData[0].imageUrl || tableData[0].productPic"
                class="picImg"
                :src="tableData[0].imageUrl || tableData[0].productPic"
                :preview-src-list="[tableData[0].imageUrl || tableData[0].productPic]">
              </el-image>
              <div class="picDesp">
                <div class="picLabel">商品</div>
                <div class="picName">{{ tableData[0].productName }}</div>
              </div>
            </div>
            <div class="timmer">{{tableData[0].createTime}} 由客户管家 官方提供</div>
          </div>
          <div class="line-hr"></div>
          <div class="textBox">
            <div v-if="!tableData[0].isEdit" class="childDesBox"><span v-html="resultTransferFn(tableData[0].productDesc || tableData[0].sellingPoint || tableData[0].replyRateContent)"></span></div>
            <template v-else>
              <el-input :maxlength="formdata.lengthCode" type="textarea" resize="none" v-model="tableData[0].productDesc" :autosize="{ minRows: 2, maxRows: 12 }"></el-input>
              <div class="bottomBtn">
                <span class="wordLimit">{{tableData[0].productDesc ? tableData[0].productDesc.length : 0}}/{{formdata.lengthCode}}</span>
                <span class="confirmBtn" @click="confirmDialogFn(tableData[0], 'current')">确定</span>
              </div>
            </template>
          </div>
          <div class="bottomImage">
            <img src="@/assets/images/gpt/icon_edit@2x.png" @click="editProductDescFn('')" title="编辑">
            <img src="@/assets/images/gpt/icon_reset@2x.png" @click="reCreateFn('')" title="重新生成">
            <img src="@/assets/images/gpt/icon_copy@2x.png" @click="copyTxtFn(tableData[0].productDesc || tableData[0].sellingPoint || tableData[0].replyRateContent, '已复制到您的鼠标剪切板')" title="复制">
            <img src="@/assets/images/gpt/icon_del@2x.png" @click="delProductDesFn(tableData[0], 'current')" title="删除">
          </div>
        </div>
      </div>
      <div class="resultParentBox" :class="{'y-mt-30': tableData.length}" v-if="historyList.length">
        <div class="tit-desp">历史记录</div>
        <div class="resultContentBox">
          <template  v-for="(item, idx) in historyList">
            <div class="resultMainBox y-mb-16" :key="idx">
              <div class="y-f y-f-a y-f-jb">
                <div class="y-f y-f-a y-f-js">
                  <el-image
                    scrollContainer=".resultContentBox"
                    lazy
                    v-if="item.imageUrl || item.productPic"
                    class="picImg"
                    :src="item.imageUrl || item.productPic"
                    :preview-src-list="[item.imageUrl || item.productPic]">
                  </el-image>
                  <div class="picDesp">
                    <div class="picLabel">商品</div>
                    <div class="picName">{{ item.productName }}</div>
                  </div>
                </div>
                <div class="timmer">{{item.createTime}} 由客户管家 官方提供</div>
              </div>
              <div class="line-hr"></div>
              <template v-for="(child, childIdx) in item.list">
                <div :key="childIdx">
                  <div class="textBox">
                    <div v-if="!child.isEdit" class="childDesBox"><span v-html="resultTransferFn(child.productDesc || child.sellingPoint || child.replyRateContent)"></span></div>
                    <template v-else>
                      <el-input :maxlength="formdata.lengthCode" type="textarea" resize="none" v-model="child.productDesc" :autosize="{ minRows: 2, maxRows: 12 }"></el-input>
                      <div class="bottomBtn">
                        <span class="wordLimit">{{child.productDesc ? child.productDesc.length : 0}}/{{formdata.lengthCode}}</span>
                        <span class="confirmBtn" @click="confirmDialogFn(child)">确定</span>
                      </div>
                    </template>
                  </div>
                  <div class="bottomImage">
                    <img src="@/assets/images/gpt/icon_edit@2x.png" @click="editProductDescFn(child, idx, childIdx)" title="编辑">
                    <img src="@/assets/images/gpt/icon_reset@2x.png" @click="reCreateFn(child, idx, childIdx)" title="重新生成">
                    <img src="@/assets/images/gpt/icon_copy@2x.png" @click="copyTxtFn(child.productDesc, '已复制到您的鼠标剪切板')" title="复制">
                    <img src="@/assets/images/gpt/icon_del@2x.png" @click="delProductDesFn(child, idx, childIdx)" title="删除">
                  </div>
                  <div class="line-hr line-child" v-if="childIdx != item.list.length - 1"></div>
                </div>
              </template>
            </div>
          </template>
          <div v-if="hasMore" class="more">显示更多</div>
          <div v-else class="more">我也是有底线的</div>
        </div>
      </div>
    </div>    
  </div>
</template>

<script>
import { dateFormat, copyText, transferText} from '@/utils/util';
import { getStoreListApi } from '@/api/baseInfo/shopManage/storeManagement';
import { getProductDescApi, updateProductDescApi, insertProductDescApi } from '@/api/khgjgpt/copywritingAssistant/copywritingAssistant';
import { getProductSellingPointApi, updateProductSellingPointApi, insertProductSellingPointApi } from '@/api/khgjgpt/sellingPoints/sellingPoints';
import { queryOrderRatePageApi, resendRateContentApi, updateOrderRateApi } from '@/api/khgjgpt/evaluationAnalysis/orderRate';
export default {
  name: 'base-info',
  props: ['formdata', 'productDescType', 'aiLoading', 'fromPage'],
  data() {
    return {
      tableData: [],
      timeTxt: '',
      historyList: [],
      allPlatformCode: ['TAOBAO', 'PDD', 'LUBAN', 'KS', 'JD', 'ALI_1688','XIAOHS','WXSPH'],
      page: {
        pageNo: 1,
        limit: 10,
        total: 0
      },
      currentRow: {},
      hasMore: false,
      isHistoryListLoading: false,
      isDisabled: false
    };
  },
  watch: {
    aiLoading(val) {
      this.isDisabled = val || false;
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
    emptyTip() {
      let title = '';
      let desp = '';
      switch (this.fromPage) {
        case 'mdfx':
          title = '卖点分析';
          desp = '智多星根据您选择的商品帮您分析产品卖点关键词，生成卖点分析，针对性优化商品卖点，提升销量';
          break;
        case 'xhswa':
          title = '小红书文案';
          desp = '智多星根据您选择的商品帮您生成小红书风格的文案，您的商品就是下一个小红书爆款~';
          break;
        case 'scwa':
          title = '商品好评文案';
          desp = '智多星模拟真实买家口吻，根据您选择的商品生成商品好评文案。售后客服的最爱~';
          break;
        case 'spbt':
          title = '商品标题';
          desp = '智多星融合前沿科技与市场洞察，为您的商品定制高频率点击的标题，抢占竞争优势，提升商品销量。你的商品就是下一个爆款!';
          break;
        case 'spsxwa':
          title = '商品上新';
          desp = '告别繁琐编辑，一键生成风格多样的上新文案，大幅提升产品吸引力。';
          break;
        default: ''
      }
      return {
        title,
        desp
      }
    }
  },
  mounted() {
    this.page.pageNo = 1;
    this.hasMore = false;
    this.getCurStoreListList();
  },
  methods: {
    // 更新历史记录
    initRowResult(list) {
      if(this.historyList.length) {
        let idx = list[0].idx;
        let index = this.historyList[idx].list.findIndex(o => {return o.pppid == list[0].pppid});
        this.historyList[idx].list[index].productDesc = list[0].productDesc;
        this.historyList[idx].list[index].isEdit = true;
      }
    },
    // 更新生成结果内容
    initResult(list) {
      // 添加或编辑时先将其它编辑态取消，并将修改的内容复原，再设置其它项的编辑态
      // 历史结果复原
      this.historyList.forEach(o => {
        o.list.forEach(m => {
          m.isEdit = false;
          m.productDesc = m.productDescBak;
        })
      })
      // 新添加商品结果时，如果已有生成结果，则需查询下列表，将已有的生成结果改为历史结果，再生成新的结果--这种情况暂时不考虑
      // if (this.tableData.length && this.tableData[0].pppid && !this.isDisabled) {
      //   this.queryProduct();
      // }
      // 添加新商品结果或编辑已有商品结果
      this.tableData = JSON.parse(JSON.stringify(list));
      this.tableData[0].createTime = `${dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')}`;
      this.tableData[0].isEdit = true;
      let dom = document.getElementById('mainBox');
      dom.scrollTop = 0;
    },
    // 获取当前店铺下拉列表
    getCurStoreListList() {
      this.storeList = [];
      let params = {
        pageNo: 1,
        limit: 100000,
        paltformCodeList: this.allPlatformCode
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getStoreListApi(params).then(res => {
        if (res.message === 'ok') {
          // 店铺按平台归类，顺序为：淘宝、拼多多、抖音、快手；
          let list = res.data.items || [];
          let tbList = list.filter(o => { return o.paltformCode == 'TAOBAO'; });
          let pddList = list.filter(o => { return o.paltformCode == 'PDD'; });
          let dyList = list.filter(o => { return o.paltformCode == 'LUBAN'; });
          let ksList = list.filter(o => { return o.paltformCode == 'KS'; });
          let aliList = list.filter(o => { return o.paltformCode == 'ALI_1688'; });
          let jdList = list.filter(o => { return o.paltformCode == 'JD'; });
          let xhsList = list.filter(o => { return o.paltformCode == 'XIAOHS'; });
          let wxsphList = list.filter(o => { return o.paltformCode == 'WXSPH'; });
          let allList = [...tbList, ...pddList, ...dyList, ...ksList, ...aliList, ...jdList,...xhsList,...wxsphList];
          this.storeList = allList.filter(o => { return o.expiredStatus != 1 && o.status != 'N' && o.mallStatus != 1; }); // 获取正常店铺列表
          // this.changePlatformCode([]);
        } else {
          this.storeList = [];
        }
      }).catch(() => {
        this.storeList = [];
      }).finally(()=> {
        loadingMask.close();
        if (this.storeList.length) {
          this.queryProduct();  // 获取订单列表
        }
      })
    },
    // 获取历史记录及最近一次生成结果
    queryProduct(resObj) {
      let params = {
        loginId: this.userMess.loginId,
        pageNo: this.page.pageNo,
        limit: this.page.limit,
        mallList: this.storeList.map(o => { return {mallCode: o.mallCode, platformCode: o.paltformCode}}),
        productDescType: this.productDescType
      }
      // 查询具体商品历史记录， 不带id 查询所有商品的历史记录
      if (resObj&&resObj.pppid) {
        params.id = resObj.pppid;
        params.mallList = [{mallCode: resObj.mallCode, platformCode: resObj.platformCode}];
        params.key = resObj.productCode;
      } else if (this.tableData.length && this.tableData[0].pppid) {
        params.id = this.tableData[0].pppid;
        params.mallList = [{mallCode: this.tableData[0].mallCode, platformCode: this.tableData[0].platformCode}];
        params.key = this.tableData[0].productCode;
      }
      this.isHistoryListLoading = true;
      let apiUrlFn = '';
      if (this.productDescType == 111) {
        // 卖点分析
        apiUrlFn = getProductSellingPointApi
      } else if (this.productDescType == 222) {
        // 评价分析
        apiUrlFn = queryOrderRatePageApi
      } else {
        // 小红书文案、商品标题、商品上新、好评文案
        apiUrlFn = getProductDescApi
      }
      apiUrlFn(params).then(res => {
        if(res.code === 1) {
          if(res.data) {
            let resData = res.data.items || [];
            let currentObj = res.data.current || {};
            if (this.page.pageNo == 1) {
              this.historyList = resData;
            } else {
              this.historyList = this.historyList.concat(resData);
            }
            this.historyList.forEach((o, i )=> {
              o.list.forEach((c, ii )=> {
                c.pppid = c.id; // 新定义下id值，  新添加的商品中， 有部分平台的商品已有id，与 生成结果中的id冲突，无法区分是新增还是修改
                c.isEdit = false;
                this.$set(c, 'productDesc', c.productDesc || c.sellingPoint || c.replyRateContent || '');
                this.$set(c, 'productDescBak', c.productDesc || c.sellingPoint || c.replyRateContent || '');
              })
            })
            this.page.total = res.data.total || 0;
            this.hasMore = res.data.morePage;
            // 更新当前商品的生成结果，编辑时需要id
            if (currentObj && currentObj.list && currentObj.list.length) {
              let list = currentObj.list;
              list[0].pppid = list[0].id; // 新定义下id值，  新添加的商品中， 有部分平台的商品已有id，与 生成结果中的id冲突，无法区分是新增还是修改
              list[0].productDesc =  list[0].productDesc || list[0].sellingPoint || list[0].replyRateContent || '';
              list[0].productDescBak = list[0].productDesc;
              list[0].isEdit = false;
              this.tableData = [...list];
            }
          } else {
            this.$message.error('获取数据失败');
            // this.historyList = [];
            // this.page.total = 0;
          }
        } else {
          // this.historyList = [];
          // this.page.total = 0;
          this.$message.error(res.error);
        }
        this.isHistoryListLoading = false;
      }).catch(() => {
        this.isHistoryListLoading = false;
        // this.historyList = [];
        // this.page.total = 0;
      }).finally(()=>{
        let dom = document.getElementById('mainBox');
        dom.addEventListener('scroll', (e)=>{
          let el = e.target;
          if ((el.scrollTop + el.offsetHeight) > (el.scrollHeight - 20)) {
            // 表格分页，加载更多
            if (this.hasMore && !this.isHistoryListLoading) {
              this.page.pageNo += 1;
              this.queryProduct();
            }
          }
        })
      });
    },
    confirmDialogFn(item, flag) {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      if (!item.productDesc) {
        this.$message.error('文案不能为空');
        return false;
      }
      let params = {
        loginId: this.userMess.loginId,
        mallCode: item.mallCode,
        mallName: item.mallName,
        platformCode: item.platformCode,
        platformName: item.platformName,
        productCode: item.productCode,
        productName: item.productName,
        productShortName: item.productShortName,
        productDesc: item.productDesc,
        productPic: item.imageUrl || item.productPic,
        productDescType: this.productDescType,
      };
      let apiUrl = '';
      if (item.pppid) {
        params.id = item.pppid;
        params.isDelete = 0;
        // 修改
        if (this.productDescType == 111) {
          params.sellingPoint = item.productDesc;
          apiUrl = updateProductSellingPointApi
        } else if (this.productDescType == 222) {
          params.rateType = 0;
          params.rateContent = item.rateContent;
          params.replyRateContent = item.productDesc;
          apiUrl = updateOrderRateApi
        } else {
          apiUrl = updateProductDescApi
        }
      } else {
        // 新增
        if (this.productDescType == 111) {
          params.sellingPoint = item.productDesc;
          apiUrl = insertProductSellingPointApi;
        } else if (this.productDescType == 222) {
          params.rateType = 0;
          params.rateContent = item.rateContent;
          params.replyRateContent = item.productDesc;
          apiUrl = updateOrderRateApi
        } else {
          apiUrl = insertProductDescApi
        }
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      apiUrl(params).then((res) => {
        loadingMask.close();
        if (res.message === 'ok') {
          this.$message.success('文案修改成功');
          // 如果是新增，就从第一页查询刷新列表
          this.page.pageNo = 1;
          this.hasMore = false;
          if (flag == 'current') {
            // 清除左侧选的商品信息
            this.$emit('clearPro');
          }
          let currentData = res.data;
          currentData.pppid = currentData.id;
          this.queryProduct(currentData);
        } else {
          this.$message.error(res.error || res.data || '修改失败');
        }
      }).catch((err) => {
        loadingMask.close();
        this.$message.error(err.error || err.message || '网络异常，请稍候重试');
      }).finally(()=>{
        let dom = document.getElementById('mainBox');
        dom.scrollTop = 0;
      });
    },
    // 编辑
    editProductDescFn(row, idx, childIdx) {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      if (!row) {
        if (this.tableData[0].isEdit) {
          return false;
        }
        // 编辑时先将其它编辑态取消，并将修改的内容复原，再设置其它项的编辑态
        // 历史结果复原
        this.historyList.forEach(o => {
          o.list.forEach(m => {
            m.isEdit = false;
            m.productDesc = m.productDescBak;
          })
        })

        this.tableData[0].isEdit = true;
        if (this.productDescType == 111) {
          this.tableData[0].productDesc = this.tableData[0].sellingPoint;
        } else if (this.productDescType == 222) {
          this.tableData[0].productDesc = this.tableData[0].replyRateContent;
        }
        this.tableData = [...this.tableData];
      } else {
        // 编辑时先将其它编辑态取消，并将修改的内容复原，再设置其它项的编辑态
        // 生成结果复原
        if (this.tableData.length && this.tableData[0].pppid) {
          this.tableData[0].isEdit = false;
          this.tableData[0].productDesc = this.tableData[0].productDescBak;
          this.tableData = [...this.tableData];
        }
        // 历史结果复原
        this.historyList.forEach(o => {
          o.list.forEach(m => {
            m.isEdit = false;
            m.productDesc = m.productDescBak;
          })
        })
        
        this.historyList[idx].list[childIdx].isEdit = true;
        this.historyList = [...this.historyList];
      }      
    },
    copyTxtFn(txt, tip) {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      if (txt) {
        txt = txt.replace(/\<br \/\>/g, '\n').replace(/\<br\/\>/g, '\n').replace(/\<br\>/g, '\n').replace(/\<br \>/g, '\n');
      }
      copyText(txt, tip);
    },
    // 重新生成
    reCreateFn(row, idx) {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      if (!row) {
        if (this.productDescType == 111) {
          this.tableData[0].productDesc = this.tableData[0].sellingPoint;
        } else if (this.productDescType == 222) {
          this.tableData[0].productDesc = this.tableData[0].replyRateContent;
        }
        this.currentRow = this.tableData[0];
        this.currentRow.isCurrent = true;
      } else {
        this.currentRow = row;
        this.currentRow.isCurrent = false;
        this.currentRow.idx = idx;
      }
      this.$emit('recreate', this.currentRow);
    },
    // 删除此记录
    delProductDesFn(row, flag) {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      // 刚生成的信息，还没有保存到后端，直接删除前端数据
      if (!row.pppid && flag == 'current') {
        this.tableData = [];
        this.$emit('clearPro');
        return false;
      }
      this.$confirm('确认要删除吗，删除后无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.pppid,
          isDelete: 1,
          mallCode: row.mallCode,
          mallName: row.mallName,
          platformCode: row.platformCode,
          platformName: row.platformName,
          productCode: row.productCode,
          productName: row.productName,
          productShortName: row.productShortName,
          productDesc: row.productDesc,
          sellingPoint:row.productDesc,
        };
        let apiUrl = '';
        if (this.productDescType == 111) {
          apiUrl = updateProductSellingPointApi
        } else if (this.productDescType == 222) {
          apiUrl = updateOrderRateApi
        } else {
          apiUrl = updateProductDescApi
        }
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });
        apiUrl(params).then((res) => {
          loadingMask.close();
          if (res.message === 'ok') {
            this.$message.success('删除成功');
            if (flag == 'current') {
              // 删除的是当前商品
              this.tableData = [];
              this.$emit('clearPro');
            }
            this.page.pageNo = 1;
            this.hasMore = false;
            this.queryProduct();
          } else {
            this.$message.error(res.error || res.data || '删除失败');
          }
        }).catch((err) => {
          loadingMask.close();
          this.$message.error(err.error || err.message || '网络异常，请稍候重试');
        });
      }).catch(() => {
        return false;          
      });
    },
    resultTransferFn(resVal) {
      return transferText(resVal);
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../../styles/variables";
.showResultBox {
  height: calc(100vh - 72px);
  min-height: 819px;
  position: relative;
  overflow-y: auto;
}
.tit-desp {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 10px;
}
.emptyBox {
  width: 510px;
  height: 92px;
  margin: 0 auto;
  padding-top: 24%;
  .robotImg {
    width: 136px;
    height: 91px;
    margin-right: 16px;
  }
  .emptyRight {
    .emptyTitle {
      width: 128px;
      height: 38px;
      background: #FFFFFF;
      border-radius: 8px;
      line-height: 38px;
      text-align: center;
      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-right: 8px;
      }
      span {
        font-weight: bold;
        font-size: 16px;
        color: #272727;
        line-height: 19px;
      }
    }
    .emptyDesp {
      font-weight: 300;
      font-size: 14px;
      color: #7E7E7E;
      line-height: 20px;
      margin-top: 8px;
    }
  }
}
.resultParentBox {
  .resultMainBox {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 14px;
  }
  .picImg {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    margin-right: 5px;
  }
  .picDesp {
    .picLabel {
      width: 38px;
      height: 18px;
      background: #E6D9FF;
      border-radius: 4px;
      font-weight: 400;
      font-size: 12px;
      color: #653EB3;
      line-height: 18px;
      text-align: center;
    }
    .picName {
      font-weight: 400;
      font-size: 12px;
      color: #6A6A6A;
      line-height: 17px;
    }
  }
  .timmer {
    font-weight: 400;
    font-size: 12px;
    color: #6A6A6A;
    line-height: 17px;
  }
  .line-hr {
    height: 1px;
    background: #000000;
    opacity: 0.1;
    margin-top: 14px;
  }
  .line-child {
    width: calc(100% - 8px);
    margin: 0 auto;
    margin-top: 14px;
  }
  .textBox {
    position: relative;
    background: #F4F4F4;
    border-radius: 4px;
    margin-top: 14px;
    .bottomBtn {
      position: absolute;
      width: 180px;
      bottom: 8px;
      right: 8px;
      border-radius: 4px;
      height: 28px;
      background: #fff;
      text-align: right;
      .wordLimit {
        font-weight: 400;
        font-size: 14px;
        color: #7C7C7C;
        line-height: 20px;
      }
      .confirmBtn {
        padding: 3px 12px;
        background: rgba(101, 62, 179, 0.1);
        border-radius: 4px;
        font-weight: 400;
        font-size: 16px;
        color: #653EB3;
        line-height: 28px;
        margin-left: 16px;
        cursor: pointer;
      }
    }
  }
  .bottomImage {
    text-align: right;
    margin-top: 10px;
    img {
      width: 16px;
      height: 16px;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  .y-mb-16 {
    margin-bottom: 14px;
  }
  .y-pb-42 {
    padding-bottom: 42px;
  }
  .childDesBox {
    padding: 14px;
    line-height: 22px;
    background: #F4F4F4;
    border-radius: 4px;
  }
  .more {
    text-align: center;
    font-size: 14px;
    color: #999;
  }
}
/deep/ .el-textarea.el-input--small textarea{
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px #B492F6;
  border-radius: 4px;
  border: 1px solid #653EB3;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  line-height: 22px!important;
  padding-bottom: 40px;
}
</style>
